<template>
    <div>
        <h5 class="pb-1 mb-4 f-140" :class="report_theme_color">ESG {{ $t('개선') }} {{ $t('권고사항') }}</h5>

        <template v-if="is_recommendations_by_company_loaded === true">
            <div v-for="(item, index) in recommendations_by_company"
                :key="`improvement-recommendations-${index}`"
                class="pt-4"
                >
                <b-badge :variant="report_theme_variant_badge" class="mb-3 f-100">
                    {{ $t(`권고사항`) }} {{ index + 1 }}.
                </b-badge>
                <div class="d-flex justify-content-between pb-5"
                    :class="index + 1 < recommendations_by_company.length ? 'border-bottom border-color-gray-400 border-bottom-style-dashed' : ''">
                    <div style="width:260px">
                        <h4 class="mb-2 fw-500 f-130">
                            {{ $i18n.locale === 'en' ? item.title_e : item.title }}
                        </h4>
                    </div>
                    <div v-if="$i18n.locale === 'en'"
                        style="width: calc(100% - 280px)"
                        class="line-height-lg should-html"
                        >{{ brToNewline(item.recommendation_e) }}</div>
                    <div v-else
                        style="width: calc(100% - 280px)"
                        class="text-justify font-scale-3 line-height-lg f-100 should-html"
                        >{{ brToNewline(item.recommendation) }}</div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ToBeImproved',
    props: {
        mode: {
            type: String
        },
    },
    data () {
        return {}
    },
    computed: {
        ...mapState('reviews', ['conclusion_by_company', 'is_conclusion_by_company_loaded', 'recommendations_by_company', 'is_recommendations_by_company_loaded']),
        report_theme_color () {            
            if (this.mode === 'audit') {
                return 'border-bottom border-color-red border-width-2 red8'
            } else {
                return 'border-bottom border-color-report1 border-width-2 c-report1'
            }
        },
        report_theme_variant_badge () {
            if (this.mode === 'audit') {
                return 'basic'
            } else {
                return 'report1'
            }
        }
    },
    methods: {
        // 입력이 평문 textarea 라 출력도 평문으로. 예전에 <br> 로 줄을 바꿔 저장한 글은 줄바꿈으로 보여 준다
        brToNewline (text) {
            return String(text ?? '').replace(/<br\s*\/?>/gi, '\n')
        },
    },
}
</script>

<style>

</style>